// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.7.3_webpack@5.77.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root_dBOQx {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--he-spacing-x-small);\n}", "",{"version":3,"sources":["webpack://./components/RequestPanelHeader/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AACJ","sourcesContent":[".root {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: var(--he-spacing-x-small);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "root_dBOQx"
};
export default ___CSS_LOADER_EXPORT___;
